import { render, staticRenderFns } from "./FilesEditDialog.vue?vue&type=template&id=1d4536a6&scoped=true&"
import script from "./FilesEditDialog.vue?vue&type=script&lang=js&"
export * from "./FilesEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./FilesEditDialog.vue?vue&type=style&index=0&id=1d4536a6&lang=scss&scoped=true&"
import style1 from "./FilesEditDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4536a6",
  null
  
)

export default component.exports